<div class="footer flex">
  <div class="flex-auto flex items-center container justify-between">
    <p class="flex-none">Copyright &copy; Interlog Services. <ng-container i18n>All rights reserved.</ng-container></p>
    <div class="hidden sm:block">
      <img class="logo select-none" src="./assets/img/logo-interlog-services.svg">
    </div>
  </div>
</div>
